<template>
  <section class="o-logoListing">
    <div class="o-container o-container--xlarge">
      <h2 class="u-centered">{{ title }}</h2>
      <VueSlickCarousel v-bind="sliderSettings"  v-if="translatedList.length > 0" style="position: relative">
        <div
          v-for="logo in translatedList"
          :key="logo._id"
        ><card-logo :data="logo" /></div>
      </VueSlickCarousel>

      <div class="u-centered" v-if="translatedList.length === 0">
        {{ $t('components.logoListing.notAvailable') }}
      </div>
    </div>
  </section>
</template>

<script>
import CardLogo from './CardLogo'
import ApiService from '@/services/ApiService'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'


import { getLocalizationInExcludes, localize } from '@/assets/js/helper'

export default {
  name: 'BosLogoListing',
  components: { CardLogo, VueSlickCarousel },
  props: {
    title: {
      type: String,
      default: ''
    },
    purple: Boolean
  },
  data() {
    return {
      list: [],
      sliderSettings: {
        arrows: true,
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        swipeToSlide: true,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true,
        pauseOnFocus: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              infinite: true,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            }
          },
        ]
      }
    }
  },
  computed: {
    translatedList() {
      let inAndExcludes = getLocalizationInExcludes(this.$i18n.locale)
      return localize(
        this.list,
        inAndExcludes.include,
        inAndExcludes.exclude
      ).filter(
        item =>
          item.url !== undefined &&
          item.url !== null &&
          item.url.length > 0 &&
          item.logo !== undefined &&
          item.logo !== null &&
          item.logo.length > 0
      )
    }
  },
  methods: {
    getListing() {
      ApiService.getCurrentFairWallEntries().then(response => {
        this.list = response.data
      })
    }
  },
  created() {
    this.getListing()
  }
}
</script>

<style lang="scss" scoped>
.o-logoListing {
  background-color: transparent;
  padding: 0 0 4.5rem;

  .o-grid {
    justify-content: center;
  }

  &.purple {
    background-color: #635971;
    color: #f7f6f3;
  }
}
</style>
<style lang="scss">
.slick-slide {
  display: inline-block;
}

.slick-list {
  overflow: hidden;
}

.slick-prev:before, .slick-next:before {
  color: black;
}

.slick-prev {
    left: -10px;
}

.slick-next {
    right: -10px;
}
</style>
